import {type AppId, type ContactType, type StoreAppState, type StoreAppType} from 'web-app/util/graphql/api-types';

export type StoreApp = {
    storeAppId: AppId;
    storeAppType: StoreAppType;
    storeAppState: StoreAppState;
    package: {
        packageId: string;
    } | null;
};

export const UkPackageId = {
    Freemium: '8e4ce6c3-9368-43cf-8473-cd93be124d84',
    Starter: '9aa7f3c0-990a-4eb0-952f-b724020d0ff7',
    Essentials: 'f0801cde-7388-408d-8dc4-2eae51d90cd6',
    Premium: '20991563-f3ac-44f9-a92f-e05b930bb4d6',
    NewFreemium: 'f9085654-599a-474e-8152-f8c1e642ff4f',
    ProfessionalUK: '6a24f9a5-32a2-4676-a155-75e1ff303eec',
    ChildminderUK: '042093da-a9cf-45fe-8588-ef59707bb21b',
    Tier1: 'a2c4bb39-1fc5-4864-9ec3-60f5572cc1d4',
    Tier2: '2255c108-4c4e-4cd8-876d-cd7f60c691c1',
    Tier1Connect: '5ad96952-6d4a-4b81-ae6e-16d007363a9a',
    Tier1Learn: '88c6236e-8184-4137-b27d-4d634c297889',
    Tier1Grow: 'b9325d78-cf49-400c-bf8b-4b953c421dbc',
    Tier1Simplify: 'e3a240b3-d2c3-4fc4-8569-7f480bd321ea',
} as const;
export type UkPackageId = typeof UkPackageId[keyof typeof UkPackageId];

// This type should only exist until we have a note copy for each ContactType in web-app/react/famly-store/helpers/helpers -> getSalesContactNoteCopy function
export type SalesContactTypesWithNoteCopies =
    | ContactType.CustomerWantsToUpgradePackage
    | ContactType.CustomerOnTrialWantsNewTrial;
